<!-- Vehicle Count Modifier Dialog -->
<div class="dialog-container">
  <div class="dialog-header">
    <h2>{{title}}</h2>
    <button mat-icon-button (click)="cancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form">
    <div class="form-grid">
      <!-- Left Column -->
      <div class="form-column">
        <div class="form-field">
          <mat-form-field appearance="outline" class="full-width large-font">
            <mat-label>Select Vehicle Type</mat-label>
            <mat-select formControlName="vehicleType">
              <mat-option *ngIf="isLoading">Loading...</mat-option>
              <mat-option *ngFor="let type of vehicleTypes" [value]="type.id">
                {{type.categoryName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-field" formGroupName="vehicleDetails" *ngIf="showVehicleDetails">
          <mat-form-field appearance="outline" class="full-width large-font">
            <mat-label>Maximum Capacity</mat-label>
            <input matInput type="number" formControlName="maxLoadVolume" min="0">
            <span matSuffix>CBM</span>
          </mat-form-field>
        </div>

        <div class="form-field" formGroupName="vehicleDetails" *ngIf="showVehicleDetails">
          <mat-form-field appearance="outline" class="full-width large-font">
            <mat-label>Cost Per KM</mat-label>
            <input matInput type="number" formControlName="costPerKM" min="0">
            <span matSuffix>LKR</span>
          </mat-form-field>
        </div>
      </div>

      <!-- Right Column -->
      <div class="form-column">
        <div class="form-field">
          <mat-form-field appearance="outline" class="full-width large-font">
            <mat-label>Count</mat-label>
            <input matInput type="number" formControlName="count" [min]="isEditing ? 0 : 1">
          </mat-form-field>
        </div>

        <div class="form-field" formGroupName="vehicleDetails" *ngIf="showVehicleDetails">
          <mat-form-field appearance="outline" class="full-width large-font">
            <mat-label>Maximum Weight</mat-label>
            <input matInput type="number" formControlName="maxLoadWeight" min="0">
            <span matSuffix>Kg</span>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Full Width Section -->
    <div formGroupName="vehicleDetails" *ngIf="showVehicleDetails">
      <!-- Capacity Utilization Slider -->
      <div class="form-field">
        <div class="slider-container">
          <div class="slider-header">Vehicle Capacity Utilization</div>
          <div class="slider-row">
            <div class="slider-wrapper">
              <mat-slider
                [min]="0"
                [max]="100"
                [step]="1"
                [discrete]="true"
                [showTickMarks]="false"
                class="custom-slider">
                <input 
                  matSliderThumb
                  formControlName="capacityUtilization"
                  (input)="onSliderInput($event)" />
              </mat-slider>
            </div>
            
            <div class="percentage-input">
                <input
                  matInput
                  type="number"
                  [value]="form.get('vehicleDetails.capacityUtilization')?.value"
                  (input)="onCapacityInputChange($event)"
                  min="0"
                  max="100">
              <span>%</span>
            </div>
          </div>
          
          <div class="slider-labels">
            <span>0%</span>
            <span>100%</span>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaveButtonDisabled() || isLoading">
        {{isEditing ? 'Save' : 'Add'}}
      </button>
    </div>
  </form>
</div>